import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';

const PREFIX = 'AddressDialog';

export const classes = {
  root: `${PREFIX}-root`,
  text: `${PREFIX}-text`,
  description: `${PREFIX}-description`,
  warning: `${PREFIX}-warning`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
  input: `${PREFIX}-input`,
  btn: `${PREFIX}-btn`,
  form: `${PREFIX}-form`,
  hyperlink: `${PREFIX}-hyperlink`,
  hyperlinkButton: `${PREFIX}-hyperlinkButton`,
};

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`&.${classes.root}`]: {
    [theme.breakpoints.up('xs')]: {
      paddingBottom: theme.spacing(15),
    },
  },

  [`& .${classes.text}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
    fontSize: '14px',
    fontWeight: 500,
    marginTop: 0,
  },

  [`& .${classes.description}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
    fontSize: '14px',
    fontStyle: 'italic',
  },

  [`& .${classes.warning}`]: {
    color: theme.colorTokens.error,
    fontSize: '14px',
    fontStyle: 'italic',
  },

  [`& .${classes.label}`]: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.colorTokens.onSurfaceTextTitle,
  },

  [`& .${classes.value}`]: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.colorTokens.onSurfaceTextTitle,
  },

  [`& .${classes.input}`]: {
    fontSize: '12px',
  },

  [`& .${classes.btn}`]: {
    borderRadius: '2rem',
    marginLeft: '0 !important',
    whiteSpace: 'nowrap',
  },

  [`& .${classes.form}`]: {
    display: 'grid',
    gridAutoFlow: 'row',
    [theme.breakpoints.up('sm')]: {
      gridAutoFlow: 'column',
      gridTemplateColumns: '100px 1fr',
    },
  },

  [`& .${classes.hyperlink}`]: {
    color: theme.colorTokens.hyperlink,
  },

  [`& .${classes.hyperlinkButton}`]: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
    },
  },
}));

